// axios.js
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_TAURIAN_API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

// Auth: registered immediately so first-paint API calls get the token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let loadingConfigured = false;

// Loading + 401: called once from App after LoadingProvider is ready
export const configureAxios = (setLoading) => {
  if (loadingConfigured) return;
  loadingConfigured = true;

  let requestCount = 0;

  const redirectIfUnauthorized = (error) => {
    if (error.response && error.response.status === 401) {
      const role = localStorage.getItem('role');
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      window.location.href =
        role === 'partner' ? '/partner/verify/login' : '/Login';
    }
  };

  axiosInstance.interceptors.request.use(
    (config) => {
      if (config.skipLoader) return config;
      if (requestCount === 0) setLoading(true);
      requestCount++;
      return config;
    },
    (error) => Promise.reject(error)
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      if (response.config?.skipLoader) return response;
      requestCount--;
      if (requestCount === 0) setLoading(false);
      return response;
    },
    (error) => {
      if (!error.config?.skipLoader) {
        requestCount--;
        if (requestCount === 0) setLoading(false);
      }
      redirectIfUnauthorized(error);
      return Promise.reject(error);
    }
  );
};

export default axiosInstance;
